import React from 'react'
import { RightDrawer } from '@/shared/ui/RightDrawer'
import { Menu } from 'lucide-react'

export type SettingsItem = { key: string; label: string; render: () => React.ReactNode }

export default function UserSettingsShell({ items, initial }: { items: SettingsItem[]; initial?: string }) {
  const params = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '')
  const initialKey = params.get('sec') || initial || (items[0]?.key || '')
  const [active, setActive] = React.useState(initialKey)
  const [open, setOpen] = React.useState(false)
  React.useEffect(() => {
    const url = new URL(window.location.href)
    url.searchParams.set('sec', active)
    window.history.replaceState(null, '', url.toString())
  }, [active])
  const activeLabel = React.useMemo(()=> items.find(i=> i.key===active)?.label || 'Configurações', [items, active])
  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-[220px,1fr]">
      {/* Mobile toolbar */}
      <div className="md:hidden -mb-4">
        <div className="flex items-center justify-between">
          <div className="text-lg font-semibold truncate">{activeLabel}</div>
          <button onClick={()=> setOpen(true)} className="rounded-md border border-border px-3 py-2 text-sm hover:bg-muted inline-flex items-center gap-2">
            <Menu className="h-4 w-4" /> <span>Menu</span>
          </button>
        </div>
      </div>

      {/* Sidebar (desktop) */}
      <div className="hidden md:block">
        <nav className="sticky top:[76px] space-y-1">
          {items.map(it => (
            <button key={it.key} onClick={()=> setActive(it.key)}
              className={["w-full text-left px-3 py-2 rounded-md border",
                active===it.key ? 'border-primary bg-primary/10' : 'border-border hover:bg-muted/30'].join(' ')}>
              <span className="text-sm">{it.label}</span>
            </button>
          ))}
        </nav>
      </div>

      {/* Content */}
      <div>{items.find(i=> i.key===active)?.render()}</div>

      {/* Drawer (mobile) */}
      <RightDrawer open={open} onOpenChange={setOpen} title="Configurações">
        <div className="space-y-2">
          {items.map(it => (
            <button key={it.key} onClick={()=> { setActive(it.key); setOpen(false) }}
              className={["w-full text-left px-3 py-3 rounded-md border",
                active===it.key ? 'border-primary bg-primary/10' : 'border-border hover:bg-muted/30'].join(' ')}>
              <span className="text-sm">{it.label}</span>
            </button>
          ))}
        </div>
      </RightDrawer>
    </div>
  )
}

